<template>
  <div class="dispath">
    <el-form
      ref="form"
      class="dispath_form"
      :model="form"
      label-position="top"
      :rules="rules"
    >
      <div ref="insure">
        <!-- TODO:开始 -->
        <titleBlock class="title_bar" title="星级卡控">
          <div class="text-wrapper">
            <span class="text1">卡控是否开启</span>
          </div>
          <el-switch
            v-model="form.STAR_CONTROL.flag"
            class="marginBottom"
            active-color="#06B880"
            inactive-color="#D9DBDE"
          />
          <div class="text-wrapper">
            <span class="text2 tip">满足条件规则的项目运单，在进行调度派车时需卡控星级</span>
          </div>
          <template>
            <el-row
              v-for="(domain, index) in form.STAR_CONTROL.rules"
              :key="index"
              class="box-wrapper"
            >
              <el-col :span="6">
                <el-form-item
                  :prop="'STAR_CONTROL.rules.' + index + '.projectId'"
                  label="运营项目"
                  :rules="{
                    required: true, message: '请选择', trigger: 'change'
                  }"
                >
                  <el-select
                    v-model="domain.projectId"
                    filterable
                    placeholder="请选择项目"
                    @change="(val)=>changeProjectStarControl(val,index)"
                  >
                    <!-- <el-option
                      v-for="t in projectOptions"
                      :key="t.value"
                      :label="t.label"
                      :value="t.value"
                      :disabled="chooseProjectIds.includes(t.value) && domain.projectId!==t.value?true:false"
                    /> -->
                    <el-option
                      v-for="t in projectOptions"
                      :key="t.value"
                      :label="t.label"
                      :value="t.value"
                      :disabled="isDisabled(t.value, domain.starType)"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6" style="margin-left: 20px">
                <el-form-item
                  :prop="'STAR_CONTROL.rules.' + index + '.starType'"
                  label="调度对象"
                  :rules="{
                    required: true, message: '请选择', trigger: 'change'
                  }"
                >
                  <el-select
                    v-model="domain.starType"
                    filterable
                    placeholder="请选择调度对象"
                  >
                    <el-option
                      v-for="t in StarObjectList"
                      :key="t.value"
                      :label="t.label"
                      :value="t.value"
                      :disabled="isDisabledStarType(t.value, domain.projectId)"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="1" style="text-align: center;margin-top: 32px;line-height: 32px;">
                <span>>=</span>
              </el-col>
              <el-col :span="6" style="margin-right: 20px">
                <el-form-item
                  :prop="'STAR_CONTROL.rules.' + index + '.starValue'"
                  label="星级要求"
                  :rules="{
                    required: true, message: '请选择', trigger: 'change'
                  }"
                >
                  <el-select
                    v-model="domain.starValue"
                    filterable
                    placeholder="请选择星级要求"
                  >
                    <el-option
                      v-for="t in StarList"
                      :key="t.value"
                      :label="t.star"
                      :value="t.value"
                    />
                  </el-select>
                </el-form-item>
              </el-col>
              <el-button
                type="text"
                class="danger"
                @click="handleDeleteStar(index)"
              >
                删除
              </el-button>
            </el-row>
            <div class="addOrCondition_btn flex flex-center" @click="handleAddStar">
              <span>
                <i class="el-icon-plus" />添加
              </span>
            </div>
          </template>
        </titleBlock>
        <!-- TODO:结束 -->
        <titleBlock
          class="title_bar"
          title="保险投保货值规则"
        >
          <div class="text-wrapper">
            <span class="text1">订单保险</span>
            <span class="text2">
              开启后订单配送车辆将自动进行投保
              <el-tooltip placement="top">
                <div slot="content">
                  1.订单投保货值是指一装一卸的最小订单粒度进行货值投保，多装多卸场景投保货值来源多个订单投保货值求和；<br>2.客户项目若设置单独的规则将优先应用规则获取货值，未设置单独的规则将统一应用客户默认投保货值的金额。
                </div>
                <i class="el-icon-warning" />
              </el-tooltip>
            </span>
          </div>
          <el-switch
            v-model="form.INSURANCE.flag"
            class="marginBottom"
            active-color="#06B880"
            inactive-color="#D9DBDE"
          />
          <el-row v-if="form.INSURANCE.flag">
            <el-col :span="6">
              <el-form-item label="默认投保货值：" prop="INSURANCE.defaultValue">
                <el-input v-model="form.INSURANCE.defaultValue" placeholder="请输入客户默认投保货值">
                  <template slot="append">
                    元
                  </template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="margin: 0 20px">
              <el-form-item prop="INSURANCE.force">
                <template #label>
                  强制车辆投保
                  <el-tooltip placement="top">
                    <div slot="content">
                      开启后运输车辆将强制投保，关闭配置司机在运输时可以选择车辆不投保
                    </div>
                    <i class="el-icon-warning text2" />
                  </el-tooltip>
                </template>
                <el-switch
                  v-model="form.INSURANCE.force"
                  active-color="#06B880"
                  inactive-color="#D9DBDE"
                />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="投保规则优先顺序" prop="INSURANCE.insuranceType">
                <el-radio v-model="form.INSURANCE.insuranceType" label="GOODS_VALUE">
                  优先订单货值投保
                  <el-tooltip placement="top">
                    <div slot="content">
                      车辆在投保计算货值时，优先取订单上录入的货值进行计算
                    </div>
                    <i class="el-icon-warning text2" />
                  </el-tooltip>
                </el-radio>
                <el-radio v-model="form.INSURANCE.insuranceType" label="PROJECT">
                  优先项目规则投保
                  <el-tooltip placement="top">
                    <div slot="content">
                      车辆在投保计算货值时，优先取货主服务设置投保货值进行投保
                    </div>
                    <i class="el-icon-warning text2" />
                  </el-tooltip>
                </el-radio>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item
                label="投保险种"
                prop="INSURANCE.insuranceModel"
              >
                <el-select
                  v-model="form.INSURANCE.insuranceModel"
                  filterable
                  placeholder="请选择项目"
                  @change="changeDefaultInsuranceMode"
                >
                  <el-option
                    v-for="t in insuranceModelOptions"
                    :key="t.dictionaryCode"
                    :label="t.dictionaryName"
                    :value="t.dictionaryCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row
            v-for="(domain, index) in form.INSURANCE.rules"
            :key="domain.key"
            class="box-wrapper"
          >
            <el-col :span="6">
              <el-form-item
                :prop="'INSURANCE.rules.' + index + '.projectId'"
                label="运营项目"
                :rules="{
                  required: true, message: '请选择', trigger: 'change'
                }"
              >
                <el-select
                  v-model="domain.projectId"
                  filterable
                  placeholder="请选择项目"
                  @change="(val)=>changeProject(val,index)"
                >
                  <el-option
                    v-for="t in projectOptions"
                    :key="t.value"
                    :label="t.label"
                    :value="t.value"
                    :disabled="!!(domain.carType && chooseCarType[domain.carType] && chooseCarType[domain.carType].includes(t.value))"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6" style="margin-left: 20px">
              <el-form-item
                :prop="'INSURANCE.rules.' + index + '.carType'"
                label="车型"
                :rules="{
                  required: false, message: '请选择', trigger: 'change'
                }"
              >
                <el-select
                  v-model="domain.carType"
                  filterable
                  multiple
                  clearable
                  placeholder="请选择车型"
                >
                  <el-option
                    v-for="t in carTypeOptions"
                    :key="t.id"
                    :label="t.carSettingName"
                    :value="t.id"
                    :disabled="!!(domain.projectId && chooseProject[domain.projectId] && chooseProject[domain.projectId].includes(t.id))"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="4" style="margin:0 20px">
              <el-form-item
                :prop="'INSURANCE.rules.' + index + '.value'"
                label="投保货值"
                :rules="[
                  {required: true, message: '请输入投保货值', trigger: 'change'},
                  {validator:validateInsurePrice,trigger:'change'}
                ]"
              >
                <el-input v-model="domain.value" placeholder="请输入投保货值" />
              </el-form-item>
            </el-col>
            <el-col :span="4" style="margin:0 20px">
              <el-form-item
                :prop="'INSURANCE.rules.' + index + '.insuranceModel'"
                label="投保险种"
                :rules="[
                  {required: true, message: '请选择投保险种', trigger: 'change'},
                ]"
              >
                <el-select
                  v-model="domain.insuranceModel"
                  filterable
                  placeholder="请选择项目"
                  @change="changeDefaultInsuranceMode($event, index)"
                >
                  <el-option
                    v-for="t in insuranceModelOptions"
                    :key="t.dictionaryCode"
                    :label="t.dictionaryName"
                    :value="t.dictionaryCode"
                  />
                </el-select>
              </el-form-item>
            </el-col>
            <el-button
              type="text"
              class="danger"
              @click="handleDeleteInsure(index)"
            >
              删除
            </el-button>
          </el-row>
          <div class="addOrCondition_btn flex flex-center" @click="handleAddInsure">
            <span>
              <i class="el-icon-plus" />添加投保规则
            </span>
          </div>
        </titleBlock>
        <titleBlock title="超时处理">
          <div class="flex align-center marginBottom">
            <el-switch
              v-model="form.DISPATCH_OVER_TIME.flag"
              active-color="#059E84"
              inactive-color="#D9DBDE"
            />
            <span class="switch_tips">开启时流程到达节点超时触发后将自动取消，关闭后不会自动取消。</span>
          </div>
          <div v-if="form.DISPATCH_OVER_TIME.flag" class="new-flex">
            <div class="second-title required">
              流程到达该节点
            </div>
            <el-form-item
              class="overTime_trigger"
              prop="DISPATCH_OVER_TIME_CONDITION.fieldName"
            >
              <div class="receiving_time flex align-center">
                <div class="flex align-center">
                  <el-select
                    v-model="form.DISPATCH_OVER_TIME_CONDITION.fieldName"
                    placeholder="请选择"
                    class="receivingTimeType"
                  >
                    <el-option
                      v-for="item in receivingTimeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                  <el-select v-model="form.DISPATCH_OVER_TIME_CONDITION.action" class="receivingTimeTypeUnit">
                    <el-option
                      v-for="item in receivingStsgeType"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="DISPATCH_OVER_TIME_CONDITION.num">
              <div class="time_input flex align-center">
                <el-input v-model="form.DISPATCH_OVER_TIME_CONDITION.num" placeholder="请输入" />
                <el-select v-model="form.DISPATCH_OVER_TIME_CONDITION.unit">
                  <el-option
                    v-for="item in timeUnit"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <span v-if="form.overTimeTrigger!==OVERTIME_TYPE.BASIS_TABLE_FIELD" class="basis">后</span>
              </div>
            </el-form-item>
          </div>
        </titleBlock>
        <titleBlock title="运力白名单">
          <dispatchWhiteControl
            :form="form"
            :project-options="projectOptions"
            @valid="emitValidForm"
          />
        </titleBlock>
      </div>
    </el-form>
  </div>
</template>

<script>
import { processingSelectData } from '@/utils/index';
import { getProjectList } from '@/api/user';
import { twoNumberReg } from '@/utils/regExp';
import { getOptionsFromDictionary } from '@/api/base';
import titleBlock from '../assembly/titleBlock.vue';
import dispatchWhiteControl from './dispatchWhiteControl.vue';
import { getCarType, getConfigList } from '../api';
// TODO:
import {
  StarObjectList, timeReg, RECEIVING_TIME_TYPE,
  RECEIVING_STSGE_TYPE, TIME_UNIT, OVERTIME_TYPE,
} from './const';

export default {
  name: 'Dispath',
  components: {
    titleBlock,
    dispatchWhiteControl,
  },
  props: {
    customField: {
      type: Object,
      default: () => { },
    },
    customerCode: {
      type: String,
      default: null,
    },
    form: {
      type: Object,
      default: () => {},
    },
    parentProcessName: {
      type: String,
      default: '',
    },
    parentProcessCode: {
      type: String,
      default: '',
    },
  },
  data() {
    const validateInsurePrice = (rule, value, callback) => {
      if (value && value !== '') {
        if (!twoNumberReg.test(value)) {
          callback(new Error('保留两位小数(0≤范围≤99999999.99)'));
        }
        const valueArr = (`${value}`).split('.');
        if (Number(valueArr[0] > 99999999)) {
          callback(new Error('整数值最大为99999999'));
        }
        callback();
      }
      callback();
    };
    const validateTime = (rule, value, callback) => {
      if (!timeReg.test(Number(value))) {
        callback('请输入正确的时间');
      }
      callback();
    };
    return {
      validateInsurePrice,
      OVERTIME_TYPE,
      projectOptions: [],
      carTypeOptions: [],
      chooseProject: {},
      chooseCarType: {},
      rules: {
        'INSURANCE.defaultValue': [
          { required: true, message: '请输入默认投保货值', trigger: 'change' },
          { validator: validateInsurePrice, trigger: 'change' },
        ],
        'INSURANCE.force': [
          { required: true, message: '请选择强制车辆投保', trigger: 'change' },
        ],
        'INSURANCE.insuranceType': [
          { required: true, message: '请选择投保规则优先顺序', trigger: 'change' },
        ],
        'INSURANCE.insuranceModel': [
          { required: true, message: '请选择投保险种', trigger: 'change' },
        ],
        'DISPATCH_OVER_TIME.flag': [
          { required: true, message: '请选择接单设置', trigger: 'change' },
        ],
        'DISPATCH_OVER_TIME_CONDITION.fieldName': [
          { required: true, message: '请选择', trigger: 'change' },
        ],
        'DISPATCH_OVER_TIME_CONDITION.num': [
          { required: true, validator: validateTime, trigger: 'change' },
        ],
      },
      // TODO:
      StarList: [],
      StarObjectList,
      chooseProjectIds: [], // 选择的运营项目
      insuranceModelOptions: [], // 投保险种枚举
    };
  },
  computed: {
    timeUnit() {
      return processingSelectData(TIME_UNIT);
    },
    receivingTimeType() {
      return processingSelectData(RECEIVING_TIME_TYPE);
    },
    receivingStsgeType() {
      return processingSelectData(RECEIVING_STSGE_TYPE);
    },
  },
  watch: {
    customerCode: {
      handler(val) {
        if (val) {
          this.getProjectListFn();
        }
      },
      immediate: true,
    },
    'form.INSURANCE.rules': {
      handler(val) {
        if (!val || !val.length) {
          this.chooseInfo = {};
          return;
        }
        const chooseProject = {};
        const chooseCarType = {};
        val.forEach((item) => {
          if (item.projectId && item.carType) {
            const project = chooseProject[item.projectId];
            // const carType = chooseCarType[item.carType];
            chooseProject[item.projectId] = project ? [...project, item.carType] : [item.carType];
            // chooseCarType[item.carType] = carType ? [...carType, item.projectId] : [item.projectId];
            item.carType.forEach((car) => {
              const carType = chooseCarType[car];
              chooseCarType[car] = carType ? [...carType, item.projectId] : [item.projectId];
            });
          }
        });
        this.chooseProject = chooseProject;
        this.chooseCarType = chooseCarType;
      },
      immediate: true,
    },
    // TODO:
    'form.STAR_CONTROL.rules': {
      handler(val) {
        if (!val || !val.length) {
          this.chooseProjectIds = [];
          return;
        }
        this.chooseProjectIds = val.map((t) => t.projectId);
      },
      immediate: true,
    },
  },
  async created() {
    console.log('form--', this.form);
    const res = await getCarType({ pageSize: '999' });
    this.carTypeOptions = this.sortNumber(res, 'carSettingName');
    // TODO:
    const data = await getConfigList({ keys: 'oms.star.conf', appId: '1004' });
    this.StarList = JSON.parse(data.configs?.[0].value || '[]');
    console.log('getConfigList-oms.star.conf--', this.StarList);
    this.insuranceModelOptions = await getOptionsFromDictionary({ status: 1, type: 'insuranceModel' });
  },
  methods: {
    /* eslint-disable */
    sortNumber(arr, carSettingName) {
      return arr.sort((a, b) => {
        const numberA = `${parseFloat(a[carSettingName]) || a[carSettingName]}`;
        const numberB = `${parseFloat(b[carSettingName]) || b[carSettingName]}`;
        if (!isNaN(numberA) && !isNaN(numberB)) {
          if (numberA * 1 < numberB * 1) {
            return -1;
          }
          if (numberA * 1 > numberB * 1) {
            return 1;
          }
          return 0;
        }
        return numberA.localeCompare(numberB);
      });
    },
    async getProjectListFn() {
      const data = await getProjectList({
        customerCodes: [this.customerCode],
        status: 'ENABLE',
      });
      this.projectOptions = data.length > 0 ? data.map((t) => ({
        label: t.projectName,
        value: t.id,
        projectName: t.projectName,
        projectId: t.id,
      })) : [];
    },
    changeProject(val, index) {
      const tt = this.form.INSURANCE.rules[index];
      const proItem = this.projectOptions.find((t) => t.value === val);
      this.form.INSURANCE.rules.splice(index, 1, {
        ...tt,
        projectName: proItem.label,
      });
    },
    changeDefaultInsuranceMode(val, index = undefined){
      const insuranceModelObj = this.insuranceModelOptions.find(item=>item.dictionaryCode === val);
      if(index === undefined) { // 默认值投保类型
        Object.assign(this.form.INSURANCE,{
          insuranceModel: insuranceModelObj.dictionaryCode,
          insuranceModelName: insuranceModelObj.dictionaryName,
          insuranceModelOrder: insuranceModelObj.sorting,
        })
        return
      }
      const tt = this.form.INSURANCE.rules[index];
      this.form.INSURANCE.rules.splice(index, 1, {
        ...tt,
        insuranceModel: insuranceModelObj.dictionaryCode,
        insuranceModelName: insuranceModelObj.dictionaryName,
        insuranceModelOrder: insuranceModelObj.sorting,
      });
    },
    handleDeleteInsure(index) {
      // 删除投保规则
      const list = this.form.INSURANCE.rules;
      list.splice(index, 1);
      this.$set(this.form.INSURANCE, 'rules', list);
    },
    handleAddInsure() {
      // 添加投保规则
      const list = this.form.INSURANCE.rules;
      list.push({
        projectId: '',
        projectName: '',
        value: '',
      });
      this.$set(this.form.INSURANCE, 'rules', list);
    },
    async emitValidForm() {
      await this.$refs.form.validate();
    },
    async valiForm() {
      await this.$refs.form.validate();
      let data = Object.keys(JSON.parse(JSON.stringify(this.form)));
      if (!this.form.DISPATCH_OVER_TIME.flag) {
        data = data.filter((item) => item !== 'DISPATCH_OVER_TIME_CONDITION');
      }
      const res = data.map((item) => ({
        ruleCode: item,
        ruleValue: item !== 'INSURANCE' ? this.form[item] : {
          ...this.form.INSURANCE,
          force: this.form.INSURANCE.flag ? this.form.INSURANCE.force : false,
          insuranceType: this.form.INSURANCE.flag ? this.form.INSURANCE.insuranceType : 'PROJECT',
          defaultValue: this.form.INSURANCE.flag ? this.form.INSURANCE.defaultValue : '',
          rules: this.form.INSURANCE.rules && this.form.INSURANCE.rules.length > 0 ? this.form.INSURANCE.rules.map((m) => ({
            ...m,
            value: Number(m.value),
            carType: m.carType ? m.carType.join(',') : '',
          })) : [],
        },
      }));
      return {
        form: this.form,
        res,
      };
    },
    // TODO:
    handleAddStar() {
      const list = this.form.STAR_CONTROL?.rules || [];
      list.push({ starType: 'CAR' });
      this.$set(this.form.STAR_CONTROL, 'rules', list);
    },
    // TODO:
    handleDeleteStar(index) {
      const list = this.form.STAR_CONTROL.rules;
      list.splice(index, 1);
      this.$set(this.form.STAR_CONTROL, 'rules', list);
    },
    // TODO:
    changeProjectStarControl(val, index) {
      const tt = this.form.STAR_CONTROL.rules[index];
      const proItem = this.projectOptions.find((t) => t.value === val);
      this.form.STAR_CONTROL.rules.splice(index, 1, {
        ...tt,
        projectName: proItem.label,
      });
      const CAR = this.form.STAR_CONTROL.rules.filter((t) => t.projectId === val && t.starType === 'CAR');
      const DRIVER = this.form.STAR_CONTROL.rules.filter((t) => t.projectId === val && t.starType === 'DRIVER');
      if(CAR.length > 1) {
        this.$message.warning('同一个项目只能配置一个车辆!');
        this.form.STAR_CONTROL.rules.splice(index, 1, {
          ...tt,
          projectName: proItem.label,
          starType: 'DRIVER'
        });
        // const list = this.form.STAR_CONTROL?.rules || [];
        // console.log('list--', list);
        // list[index] = { ...(list[index]), starValue: list[index].starValue || '', starType: 'DRIVER' };
        // this.$set(this.form.STAR_CONTROL, 'rules', list);
      } else if (DRIVER.length > 1) {
        this.$message.warning('同一个项目只能配置一个司机!');
        this.form.STAR_CONTROL.rules.splice(index, 1, {
          ...tt,
          projectName: proItem.label,
          starType: 'CAR'
        });
        // const list = this.form.STAR_CONTROL?.rules || [];
        // console.log('list--', list);
        // list[index] = { ...(list[index]), starValue: list[index].starValue || '', starType: 'CAR' };
        // this.$set(this.form.STAR_CONTROL, 'rules', list);
      }
    },
    isDisabled(projectId, starType) {
      // console.log('isDisabled--', projectId, starType);
      let flag = false;
      if (this.chooseProjectIds.includes(projectId)) {
        const CAR = this.form.STAR_CONTROL.rules.filter((t) => t.projectId === projectId && t.starType === 'CAR');
        const DRIVER = this.form.STAR_CONTROL.rules.filter((t) => t.projectId === projectId && t.starType === 'DRIVER');
        // console.log(CAR, DRIVER);
        if(CAR.length >= 1 && DRIVER.length >= 1) {
          flag = true;
        }
      }
      return flag;
    },
    isDisabledStarType(starType, projectId) {
      // console.log('isDisabledStarType--', starType, projectId);
      let flag = false;
      if (this.chooseProjectIds.includes(projectId)) {
        const CAR = this.form.STAR_CONTROL.rules.filter((t) => t.projectId === projectId && t.starType === starType);
        // console.log(CAR);
        if(CAR.length >= 1) {
          flag = true;
        }
      }
      return flag;
    },
  },
};
</script>

<style lang="scss" scoped>
.dispath {
  padding: 24px 24px 40px 24px;
  ::v-deep .el-select{
    width: 100%;
  }
  .text-wrapper {
    display:flex;
    align-items: center;
    .text1{
      font-size: 14px;
      color:#404B5C;
    }
  }
  .text2{
    font-size: 13px;
    color:#808792;
    margin-left:8px;
  }
  ::v-deep .el-radio.is-checked {
    .text2 {
      color:#06B880;
    }
  }
  .addOrCondition_btn{
    cursor: pointer;
    height: 38px;
    border: 1px dashed #B3B7BE;
    font-size: 14px;
    margin-bottom: 24px;
    .el-icon-plus{
      margin-right: 10px;
    }
    &:hover{
      border-color: #51CDA6;
      color: #51CDA6;
    }
    &:focus{
      border-color: #059366;
      color: #059366;
    }
  }
  .danger{
    color:red;
    position: relative;
    top:30px;
  }
}
.new-flex {
  display:flex;
  flex-wrap:wrap;
  .second-title{
    color:#404B5C;
    margin-bottom:8px;
    width:100%;
  }
  ::v-deep .el-form-item {
    margin-right:16px;
    .el-select{
      margin-right:8px;
    }
    .el-input{
      margin-right:8px;
    }
  }
}
.required:before{
  content:'*';
  color:red;
}
.marginBottom{
  margin:8px 0 24px;
}
.switch_tips{
  margin-left:12px;
  font-size: 13px;
  color:#808792;
}
</style>
